import { apiClient, TASK_PRIORITIES } from '../../../shared/api';

export const fetchTaskPriorities = async () => {
  const response = await apiClient.get(TASK_PRIORITIES);

  return response.data;
};
